export const font = {
    regular: "PostSans-Regular, Arial, sans-serif",
    bold: "PostSans-Bold, Arial, sans-serif"
}